var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/kejian_future.png"}})])
}]

export { render, staticRenderFns }